import { createReducer } from '@ngrx/store';

import { initialState, IUserPrefsState } from '../state';


export const reducer = createReducer<IUserPrefsState>(
	initialState,
);
